// extracted by mini-css-extract-plugin
export default {"menu":"LabelMenu_menu__umlOo","ruBackground":"LabelMenu_ruBackground__mm2Zp","enBackground":"LabelMenu_enBackground__y5fFA"};